export interface FloaterDimensions {
  left: string;
  top: string;
  width: string;
  height: string;
  zIndex: string;
}

const getFloaterPosition = (target: HTMLElement): FloaterDimensions => {
  const computedStyle = getComputedStyle(target);
  const { outlineOffset } = computedStyle;

  const padding = parseFloat(outlineOffset || "0px");
  const { width, height, left, top } = target.getBoundingClientRect();

  const { left: bodyLeft, top: bodyTop } = document.body.getBoundingClientRect();

  const zIndex = computedStyle.getPropertyValue("--oc-floating-focus-v1-z-index") || "9999999999"; /*                                                                     */

  return {
    left: `${left - bodyLeft + width / 2}px`,
    top: `${top - bodyTop + height / 2}px`,
    width: `${width + padding * 2}px`,
    height: `${height + padding * 2}px`,
    zIndex,
  };
};

export const repositionElement = (
  floater: HTMLElement,
  target: HTMLElement,
  borderRadius: string,
): void => {
  const styles = getFloaterPosition(target);
  Object.assign(floater.style, styles, { borderRadius });
};
